'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dSettings$002dParser from "./java.time.format.internal.-T-T-B-P-Date-Time-Formatter-Builder$-Settings-Parser.js";
import * as $j_scala$002eruntime$002e$002dEnum$002dValue from "./scala.runtime.-Enum-Value.js";
var $p;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2() {
  this.q = null;
  this.M = 0;
  this.jZ = 0;
  $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dSettings$002dParser.$ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__(this, "INSENSITIVE", 1, "INSENSITIVE", 1);
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2 as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2 };
$p = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype = new $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dSettings$002dParser.$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
$p.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2 as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2 };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2, "java.time.format.internal.TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2", ({
  lE: 1,
  bQ: 1,
  n: 1,
  j: 1,
  a: 1,
  av: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2 as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2 };
